import { render, staticRenderFns } from "./forgets.vue?vue&type=template&id=3be4ca5e&scoped=true"
import script from "./forgets.vue?vue&type=script&lang=js"
export * from "./forgets.vue?vue&type=script&lang=js"
import style0 from "./forgets.vue?vue&type=style&index=0&id=3be4ca5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be4ca5e",
  null
  
)

export default component.exports